import { forwardRef } from 'react';
import Icon from './Icon';
import { cx } from './util';

// §2.6 Button. primary = accent-text fill · secondary = raised + border-strong · quiet = text only ·
// danger = status-danger text, filled only on the confirm step (confirmStep). 32px, 44px at ≤ 600px.
const Button = forwardRef(function Button(
  { variant = 'secondary', icon, iconOnly = false, label, confirmStep = false, loading = false, portal = false, className, children, type = 'button', disabled, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cx('ui ui-btn', `ui-btn--${variant}`, confirmStep && variant === 'danger' && 'ui-btn--danger-fill', iconOnly && 'ui-btn--icon',
        portal && 'ui-btn--portal', loading && 'ui-btn--busy', className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      aria-label={iconOnly ? label : undefined}
      title={iconOnly ? label : undefined}
      {...rest}
    >
      {loading ? <span className="ui-btn__spin" aria-hidden="true" /> : icon && <Icon icon={icon} size={portal ? 20 : 16} />}
      {!iconOnly && children}
    </button>
  );
});
export default Button;
